var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 justify-content-between align-items-center"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-auto mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("點數管理")]), _c('div', {
    staticClass: "col-12 col-xl-auto d-flex flex-column align-items-end"
  }, [_vm.query.merchant_id ? _c('div', {
    staticClass: "mb-2"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('span', {
    staticClass: "mdi mdi-download"
  }), _vm._v(" 匯出 CSV ")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-end"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "link",
      "to": {
        name: 'PersonalPoint'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _vm._v("點數異動人員 ")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "link",
      "to": {
        name: 'PointLogList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _vm._v("點數異動紀錄 ")]), _vm.$permissions.has(_vm.$permissions.consts.POINT_LOGS_IMPORT) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "inverse-info",
      "to": {
        name: 'PointImport'
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-upload"
  }), _vm._v(" 批次上傳 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.POINT_LIST_CREATE) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'PointCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增點數 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.POINT_LIST_DEDUCT) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'PointUse'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  }), _vm._v("扣除點數 ")]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "row mx-0 mb-2"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-filter",
      modifiers: {
        "collapse-filter": true
      }
    }],
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("進階搜尋 ")])], 1), _c('b-collapse', {
    staticClass: "mb-2",
    attrs: {
      "id": "collapse-filter"
    },
    model: {
      value: _vm.isAdvancedSearchVisible,
      callback: function callback($$v) {
        _vm.isAdvancedSearchVisible = $$v;
      },
      expression: "isAdvancedSearchVisible"
    }
  }, [_c('b-card', [_c('b-form', [_c('b-form-group', {
    attrs: {
      "label": "通路名稱",
      "label-cols-sm": "2",
      "label-cols-lg": "1",
      "content-cols-sm": "",
      "content-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "點數狀態",
      "label-cols-sm": "2",
      "label-cols-lg": "1",
      "content-cols-sm": "",
      "content-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.validityStatusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.validity_status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "validity_status", $$v);
      },
      expression: "query.validity_status"
    }
  })], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋會員名稱、手機、外部編碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch();
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.handleSearch();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.points,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "no-local-sorting": true
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(validity_status)",
      fn: function fn(data) {
        return [data.item.validity_status === 'active' ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("生效中")]) : data.item.validity_status === 'pending' ? _c('b-badge', {
          staticClass: "text-white",
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("未生效")]) : data.item.validity_status === 'expired' ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("已失效")]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'PointView',
              params: {
                point_id: data.item.id,
                merchant_id: _vm.query.merchant_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]), _vm.$permissions.has(_vm.$permissions.consts.POINT_LIST_MODIFY) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1",
          staticStyle: {
            "opacity": "0.65",
            "cursor": "not-allowed"
          },
          attrs: {
            "variant": "inverse-warning",
            "title": "請透過『新增點數』或『扣除點數』按鈕，調整會員點數"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.POINT_LIST_DELETE) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deletePoint(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page,
      "perPageOptions": _vm.perPageOption
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }